import type { GameStatePatch, GameStatePatchWithVersion } from '@genially/p2p-lib';

const isFinishedPatch = (patch: GameStatePatch) => {
  return (
    patch.op === 'replace' &&
    patch.path.length === 1 &&
    patch.path[0] === 'isFinished' &&
    patch.value === true
  );
};

export const hasGameFinishedPatch = (gamePatches: GameStatePatchWithVersion[]) => {
  const patches = gamePatches.flatMap(patchWithVersion => patchWithVersion.patches);

  return patches.some(isFinishedPatch);
};
